<template>
  <page-outline :title="$t('verifications.verification_title')">
    <template slot="pageContent">
      <div class="listPage" style="overflow:hidden;">
        <!-- <b-row class="form-group justify-content-end showLargeScreenOnly"> -->
          <!-- <b-col sm="2">
            <b-button class="btn" :disabled="activateSpinner"
              @click="refreshInbox()">
              <f7-icon f7="refresh"></f7-icon>
              <span class="fab-label">{{ $t('common.rfrsh') }}</span>
            </b-button>
          </b-col> -->
          <!-- <b-col sm="2">
            <b-button class="btn" :disabled="activateSpinner"
              @click="exportVerifications()">
              <f7-icon f7="cloud_download"></f7-icon>
              <span class="fab-label">{{ $t('common.exprt') }}</span>
            </b-button>
          </b-col> -->
        <!-- </b-row> -->

        <b-row>
          <b-col md="12">
            <div class="requestsList mb-3">
              <cm-messages-filter
                class="researchfilter"
                style="position:relative;z-index:10"
                isVerifications
                filterType="list"
                propedServiceId="7"
                :mode="this.mode"
                :randomId="randomId"
                @refreshInbox="refreshInbox()"
                @applyFilter="applyFilter($event)"
                @extractCSV="exportList()"
                buttonCreateVerify @createVerify="createVerify()">
              </cm-messages-filter>
              <!-- <b-col cols="2" offset="10">
                <b-button variant="primary" size="lg"
                  href="/verifications/create/">
                  <i class="fa-light fa-plus"></i>
                  <span>{{$t('verifications.verify')}}</span>
                </b-button>
              </b-col> -->
            </div>
            <spinner v-if="activateSpinner"></spinner>
            <div v-else>
              <table class="table table-responsive">
                <thead>
                  <th class="text-center" style="width:15%">
                    {{$t('attachments.issue_date')}}
                  </th>
                  <th class="text-center" style="width:15%">
                    {{$t('verifications.lblSIREN')}}
                  </th>
                  <th class="text-center" style="width:15%">
                    {{$t('verifications.lblSIRET')}}
                  </th>
                  <th class="text-center" style="width:25%">
                    {{$t('verifications.lblSocialReason')}}
                  </th>
                  <th class="text-center" style="width:20%">
                    {{$t('verifications.verifications_status')}}
                  </th>
                  <th class="text-center" style="width:10%">
                    {{$t('verifications.action')}}
                  </th>
                </thead>
                <tbody>
                  <template v-if="inboxMessages.length > 0">
                    <tr v-for="(result, index) in inboxMessages" :key="index"
                      class="boxRequest" @click="redirectDetails(result)">
                      <td class="text-center" :title="result.DateVerifications">{{ result.DateVerifications }}</td>
                      <td class="text-center" :title="result.Siren">{{ result.Siren }}</td>
                      <td class="text-center" :title="result.Siret">{{ result.Siret }}</td>
                      <td class="text-center" :title="result.SocialReason">{{ result.SocialReason }}</td>
                      <td class="text-center" :title="getKYCVerificationsStatus(result.Status)">
                        <b-container fluid>
                          <b-row>
                            <b-col sm="2">
                              <i class="btn btn-icon" :class="getKYCVerificationsIcon(result.Status)"></i>
                            </b-col>
                            <b-col sm="10" class="pt-2">
                              <span>{{ getKYCVerificationsStatus(result.Status) }}</span>
                            </b-col>
                          </b-row>
                        </b-container>
                      </td>
                      <td class="text-center">
                        <span class="fileClickButton"
                          @click="redirectDetails(result, result.IdKYCVerifications)">
                          {{ $t('common.cnslt') }}
                        </span>
                      </td>
                    </tr>
                  </template>
                  <tr v-else>
                    <td colspan="6" class="noResult">
                      {{ $t('common.no_result') }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <cm-pagination :maxResultsByPage="paginationObject.maxResults" :firstIndex="paginationObject.firstIndex" :nbResultsTotal="paginationObject.nbResultsTotal" :refreshEvent="paginationObject.refresh"></cm-pagination>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'

import MessagesFilter from '@/components/common/Filter'
import Spinner from '@/components/common/spinner.vue'
import pagination from "@/components/common/pagination.vue"

import { errorMessageAlert } from '@/helpers/alert'
import { statusIcon, statusLabel } from '@/helpers/labels'
import { loadPage } from '@/helpers/routing'
import PageOutline from '@/components/common/PageOutline.vue'

export default {
  name: 'VerificationsListPage',
  components: {
    'cm-messages-filter': MessagesFilter,
    'spinner': Spinner,
    'page-outline': PageOutline,
    'cm-pagination': pagination

  },
  props: {
    direction: {
      default: '2',
      type: String
    },
    modeFilter: {
      default: '1',
      type: String
    }
  },
  computed: {
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    }
  },
  data () {
    return {
      activateSpinner: false,
      filterBy: '',
      inboxMessages: [],
      completeList: [],
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      reload: false
    }
  },
  created () {
    this.reload = false
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Vérifications',
      returnUrl: ''
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0

    this.mode = parseInt(this.modeFilter, 10)
    let that = this
    // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.$engine.settings.set({msgDirection: this.direction})

    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'verification-suppliers-list'
    this.$bus.$off('verification-suppliers-list')
    this.$bus.$on('verification-suppliers-list', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    // that.$engine.history.filter.cleanFilterCondition()
  },
  methods: {
    applyFilter (filterConditions) {
      this.reload = true
      if (filterConditions.modeFilter !== undefined && filterConditions.modeFilter !== this.mode) {
        this.mode = filterConditions.modeFilter
      }

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      this.$engine.services.verifications.update(
        this.direction,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        this.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        this.paginationObject.nbResults = resp.data.KYCVerificationsHistory.length
        requests = resp.data.KYCVerificationsHistory
        // requests = requests.slice(that.paginationObject.firstIndex - 1, that.paginationObject.firstIndex - 1 + that.paginationObject.maxResults)
        for (var i = 0; i < requests.length; i++) {
          if (requests[i].GlobalStatus === '') {
            requests[i].Status = '3'
          } else {
            requests[i].Status = requests[i].GlobalStatus
          }
        }
        this.updateInbox(requests)
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        this.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        // this.$$('.infinite-scroll').append(
        // '<div class="infinite-scroll-preloader"><div class="preloader"></div></div>'
        // )
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    createVerify () {
      loadPage(this, { url: '/verifications/create/' })
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    exportList () {
      let filterConditions = {}
      if (this.reload) {
        filterConditions = this.$engine.services.verifications.filter.getConditionObject()
      } else {
        filterConditions = this.$engine.services.verifications.filter.getDefaultFilter()
      }
      this.$engine.services.verifications.getExport(
        filterConditions
      ).then( resp => {
        let list = {}
        list = resp.data.ExportVerifications
        this.updateList(list)
        this.extractCSV(this.completeList)
      }).catch(e => {
        errorMessageAlert(e, this, this.$i18n)
      })
    },
    extractCSV () {
        this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))

        let firstLine = this.$t('attachments.issue_date') + ';' +
          this.$t('verifications.lblSIREN') + ';' +
          this.$t('verifications.lblSIRET') + ';' +
          this.$t('verifications.lblSocialReason') + ';' +
          this.$t('verifications.verifications_status') + '\r\n'
        let line = atob(this.completeList.result)
        let data = firstLine + line
        this.$f7.hidePreloader()
        let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
        let downloadLink = document.createElement('a')
        let today = moment()
        let fileName = 'Verifications_' + today.unix() + '.csv'

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
    },
    getKYCVerificationsIcon (status) {
      return statusIcon('KYCVerifications_' + status)
    },
    getKYCVerificationsStatus (status) {
      return statusLabel(this.$i18n, 'KYCVerifications_' + status)
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onInfinite () {
      if (this) {
        return
      }
      if (this.scrollFlag) {
        this.scrollFlag = false
        let that = this
        this.pageCounter = this.pageCounter + 1
        this.paginationObject['firstIndex'] = this.pageCounter * this.paginationObject['maxResults'] + 1
        this.paginationObject['nbResultsTotal'] = 0

        let filterConditions
        if (this.$engine.verifications.filter.getDefaultFilter()) {
          filterConditions = this.$engine.verifications.filter.getDefaultFilter()
        } else {
          filterConditions = this.$engine.verifications.filter.getConditionObject()
        }
        this.$engine.verifications.update(
          this.direction,
          this.paginationObject['maxResults'],
          this.paginationObject['firstIndex'],
          filterConditions
        ).then(resp => {
          let requests = {}
          that.requestsNumber = resp.data.actionHistory.length
          requests = resp.data.actionHistory
          that.paginationObject.nbResults = that.requestsNumber

          if (requests.length > 0) {
            for (let i = 0; i < requests.length; i++) {
              that.inboxMessages.push(requests[i])
            }
            if (requests.length < this.paginationObject['maxResults']) {
              that.detachInfinit()
            }
          } else {
            that.detachInfinit()
          }
          that.scrollFlag = true
        })
        .catch(error => {
          errorMessageAlert(error, that, that.$i18n)
          that.scrollFlag = true
        })
      }
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      // this.scrollFlag = true
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions = {}
      // console.log("index", index)
      // if (this.$engine.history.filter.getDefaultFilter()) {
      //   filterConditions = this.$engine.verifications.filter.getDefaultFilter()
      // } else {
      // }
      if (this.reload) {
        filterConditions = this.$engine.services.verifications.filter.getConditionObject()
      } else {
        filterConditions = this.$engine.services.verifications.filter.getDefaultFilter()
      }
      this.$engine.services.verifications.update(
        this.direction,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = []
        this.paginationObject.nbResultsTotal = resp.data.nbTotalResults // resp.data.KYCVerificationsHistory.length
        requests = resp.data.KYCVerificationsHistory
        //requests = requests.slice(that.paginationObject.firstIndex - 1, that.paginationObject.firstIndex - 1 + that.paginationObject.maxResults)
        for (var i = 0; i < requests.length; i++) {
          requests[i].DateVerifications = moment(requests[i].DateVerifications).format('DD/MM/yyyy HH:mm:ss')
          if (requests[i].GlobalStatus === '') {
            requests[i].Status = '3'
          } else {
            requests[i].Status = requests[i].GlobalStatus
          }
          // requests[i].Status = '1'
          // for (var j = 0; j < requests[i].CodeList.length; j++) {
          //   let code = requests[i].CodeList[j].Code
          //   if ((requests[i].Status === '1' || requests[i].Status === '2' || requests[i].Status === '3') &&
          //     (code === '00000' || code === '00020' || code === '01000' || code === '01010' || code === '14000')) {
          //     requests[i].Status = '4'
          //   } else if ((requests[i].Status === '1' || requests[i].Status === '2') &&
          //     (code === '03000' || code === '12000' || code === '10010' || code === '10020' || code === '11010' || code === '13000')) {
          //     requests[i].Status = '3'
          //   } else if (requests[i].Status === '1' &&
          //     (code === '10010' || code === '10020' || code === '10030' || code === '11010' || code === '13000')) {
          //     requests[i].Status = '2'
          //   } else if (requests[i].Status === '1') {
          //     requests[i].Status = '1'
          //   }
          // }
          // add check score and adapt status if status === '1' check méthode et try to find easier way (table instead of object ?)
          // if (requests[i].Status === '1' && (Object.keys(requests[i].score_min).length !== 0 && Object.keys(requests[i].score_req).length !== 0)) {
          //   for (let property in requests[i].score_min) {
          //     if (!this.checkStatus(property, requests[i])) {
          //       requests[i].Status = '4'
          //     }
          //   }
          // }
        }
        this.updateInbox(requests, noAttach)
        this.$f7.pullToRefreshDone()
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    checkStatus (name, tab) {
      if (tab.score_req[name + '_req'] === '1') {
        if (tab[name + '_score'] !== '' && parseInt(tab[name + '_score']) < parseInt(tab.score_min[name])) {
          return false
        }
      }
      return true
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    redirectDetails (entity, id) {
      entity.verify = false
      this.$engine.services.suppliers.selectedEntity = entity
      loadPage(this, { url: '/verifications/details/' + id})
    },
    refreshInbox () {
      this.reload = true
      this.onRefresh()
    },
    updateInbox (requests, noAttach = false) {
      this.inboxMessages = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    updateList (list) {
      this.completeList = list
    }
  }
}
</script>
